module.exports = __webpack_public_path__ + "static/mr_katahira-d9e8dc3b9cf6e19b3e7b16ac3fa66376.jpg";